import React, { FC } from 'react';

import './account-management-wrapper.css';

export const AccountManagementWrapper: FC = ({ children }) => (
    <div className="h-screen bg-tertiary-900 relative">
        <div className="adjusted-to-center absolute">{children}</div>
    </div>
);
